import React, { Component } from "react";
import Modal, { MODAL_SIZE } from "@acadia-ui/modal";
import Button from "@acadia-ui/button";

import "./modal.scss";
import ModalHelpers from "../Modals/ModalHelpers";
import FormBuilderV2 from "../../Components/FormBuilder/FormBuilderV2";
import AdvertiserFormBuilder from "../../Components/FormBuilder/AdvertiserFormBuilder";
import UpdateStateHelper from "../../Components/FormBuilder/UpdateStateHelper";
import ErrorHelpers from "../../Components/FormBuilder/ErrorHelpers";
import Dropdown from "@acadia-ui/dropdown";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import MasterCampaignsStore from "../../Flux/Stores/MasterCampaignsStore";
import { putCampaignData, fetchAdvertiserTaxonomy, createAdvertisers } from "../../Flux/Actions/MasterCampaignActions";
import Loading from "../../Components/LoadingSpinner";
import AppSDK from "@growthos/ui-app-sdk";
import { showToast, ToastNotification, TOAST_TYPE } from "@acadia-ui/toast";
import "./CreateCampaignV2.scss";
import AccessPermissions from "../../Components/FormBuilder/AccessPermissions";
const initialState = {
	formData: {},
	postData: {},
	errors: {},
	showErrors: false,
	isFormDataValid: false
};

const formEl = "master__campaign";

class CreateCampaign extends Component {
	constructor(props) {
		super(props);
		this.rowCount = 0;
		this.state = {
			...initialState,
			additionalRows: [
				{
					id: this.rowCount
				}
			],
			mediaChannelsPlatforms: this.props.mediaChannelsPlatforms,
			advertiserFields: {},
			excludedPlatformIDs: [],
			loading: false,
			totalAdvertisers: 0,
			advertisersErrors: {},
			permissionedOptions: {}
		};
	}

	componentDidMount() {
		this.props.onRef(this);
		MasterCampaignsStore.on("error_post", this.handleErrors);
		MasterCampaignsStore.on("success_post", this.handleSuccess);
		MasterCampaignsStore.on("campaign__errors__reset", this.handleReset);
		MasterCampaignsStore.on("advertisers_created_bulk_fail", this.handleAdvertiserErrors);

		this.setState({ advertiserFields: MasterCampaignsStore.getAdvertiserFields() });
	}

	componentWillUnmount() {
		this.props.onRef(undefined);
		MasterCampaignsStore.removeListener("error_post", this.handleErrors);
		MasterCampaignsStore.removeListener("success_post", this.handleSuccess);
		MasterCampaignsStore.removeListener("campaign__errors__reset", this.handleReset);
		MasterCampaignsStore.removeListener("advertisers_created_bulk_fail", this.handleAdvertiserErrors);
	}

	filterPlatforms = (arrayList) => {
		if (arrayList.length > 0) {
			const options = [];
			arrayList.forEach((platform) => {
				if (!this.state.excludedPlatformIDs.includes(platform.MasterPlatformID)) {
					options.push({ value: platform.MasterPlatformID, label: platform.PlatformName });
				}
			});
			return options;
		}
		return [];
	};

	isFormValid = () => {
		let permissionedValuesSelected = true;
		if (Object.keys(this.props.permissionedDataKeys).length) {
			const selectedPermissions = [];
			Object.values(this.state.permissionedOptions).forEach((dataValues) => {
				selectedPermissions.push(...dataValues);
			});
			if (!selectedPermissions.length) {
				permissionedValuesSelected = false;
			}
		}
		if (this.state.formData?.MasterCampaignName?.value.length > 0 && this.state.formData?.Platform?.value?.length > 0 && permissionedValuesSelected) {
			this.setState({ isFormDataValid: true });
		} else {
			this.setState({ isFormDataValid: false });
		}
	};

	updateState = (dataConfig, name, value, id, dataType, calc, disabled) => {
		if (this.state.loading === false) {
			UpdateStateHelper.update(dataConfig, name, value, id, dataType, true, formEl, this, disabled, this.props.config, false, this.isFormValid);
		}
	};

	updateCustomState = (dataConfig, name, value, id, type) => {
		// Check if we have anything in the bucket first, if not just create an empty object so it doesn't bomb out
		const postDataBucket = this.state.postData[dataConfig] ? this.state.postData[dataConfig] : {};

		// Set Default Variable
		const postDataValue = value;

		// We want Numbers to fallback to 0 for POST purposes
		// if (dataType === 'Currency' || dataType === 'Integer') {
		// 	postDataValue = value || 0;
		// } else {
		// 	postDataValue = value || null;
		// }

		// If we have a nested value it's a dropdown object so let's get the ID for the POST
		// if (postDataValue) {
		// 	if (postDataValue.value) {
		// 		postDataValue = postDataValue.value;
		// 	}
		// }

		let formDataObject = {
			...this.state.formData,
			[name]: {
				value: postDataValue
			}
		};
		if (type === "clearPlatform") {
			formDataObject = {
				...this.state.formData,
				[name]: {
					value: postDataValue
				},
				[`${id}`]: null
			};
			Object.assign(postDataBucket, { [name]: postDataValue });
		} else {
			Object.assign(postDataBucket, { [name]: postDataValue });
		}

		this.setState(
			{
				formData: formDataObject,
				postData: {
					...this.state.postData,
					[dataConfig]: postDataBucket
				}
			},
			() => {
				let excludedIDs = this.state.excludedPlatformIDs;
				if (type === "excludeID") {
					if (postDataValue) {
						excludedIDs = this.rebuildExclusionList();
					} else {
						excludedIDs = this.removePlatformFromExclusion(id);
					}
				}
				this.setState({
					excludedPlatformIDs: excludedIDs
				});
				this.isFormValid();
			}
		);
	};

	handlePlatformChange = async (selectedOptions, selectName, dataConfig, id, update, platformFieldID, fieldID) => {
		// if not already loaded, fetch the advertiser TX headers for missing platforms.
		let advertisers = MasterCampaignsStore.getAdvertiserFields();

		// map the campaign level selection to any available advertisers
		let platformsToFetch = [];
		selectedOptions?.forEach((option) => {
			if (!advertisers[option.label]) {
				const matchedAdvertiser = MasterCampaignsStore.getAdvertisers().find(({ MasterPlatformID }) => MasterPlatformID === option.value);
				const isEnabled = this.props.enabledPlatformAPIs?.find(({ MasterPlatformID }) => MasterPlatformID === matchedAdvertiser?.MasterPlatformID)?.SyncStatus === false;
				if (matchedAdvertiser && isEnabled) {
					platformsToFetch.push(matchedAdvertiser);
				}
			}
		});

		// fetch missing advertisers
		if (platformsToFetch.length > 0) {
			this.setState({ loading: true });
			await fetchAdvertiserTaxonomy(platformsToFetch);
			advertisers = MasterCampaignsStore.getAdvertiserFields();
		}
		this.setState({ advertiserFields: advertisers, loading: false });

		if (!this.state[selectedOptions.label]) {
			if (advertisers[selectedOptions.label]) {
				this.setState({ [selectedOptions.label]: { formData: {}, postData: {} } });
			}
		}
		if (this.state.formData[platformFieldID]) {
			if (this.state.formData[platformFieldID].value.label) {
				delete this.state[this.state.formData[platformFieldID].value.label];
			}
		}
		update(dataConfig, selectName, selectedOptions, id, "excludeID");
	};

	returnPlatformIds = (newRowObj) => {
		const platformIds = [];
		const formData = Object.entries(newRowObj);
		formData.forEach((element) => {
			if (element[0].indexOf("Platform") !== -1) {
				element[1].value.forEach((x) => {
					platformIds.push(x.value);
				});
			}
		});

		return platformIds.join(",");
	};

	/* This should be a helper object that formats POST JSON for the PUT Actions */
	formDataObjForPost = (newRowObj) => {
		if (Object.keys(newRowObj).length > 0) {
			const contextValues = BookFiltersStore.getContextValues();
			const postData = this.state.postData.CampaignConfig;

			/* Platform Ids will need a concatenation or something later */
			const PlatformIds = this.returnPlatformIds(newRowObj);

			const permissionedOptions = [];
			Object.keys(this.state.permissionedOptions).forEach((dataKey) => {
				this.state.permissionedOptions[dataKey].forEach((option) => {
					permissionedOptions.push(option.DataValue_MDM_GUID);
				});
			});

			const formSubmissionObj = {
				MasterAgencyDivisionName: contextValues?.agency?.name,
				MasterBusinessUnitName: contextValues?.client?.name,
				MasterCountryCode: contextValues?.country?.name,
				MasterRegionCode: contextValues?.region?.name,
				ContextID: contextValues.contextId,
				PlatformIds,
				MasterCampaignName: newRowObj.MasterCampaignName.value,
				DataValue_MDM_GUIDs: permissionedOptions.join(),
				...postData
			};

			// add the brief id if it exists
			const BriefID = AppSDK?.getBriefId();
			formSubmissionObj.BriefID = BriefID;

			/* Keep it clean, we store it but we don't need to send these */
			delete formSubmissionObj.Platform;
			delete formSubmissionObj.MediaChannel;
			/* Platforms are now PlatformIds for POST purposes */
			return formSubmissionObj;
		}
		this.setState({ errors: { Errors: ["Please fill in all form fields."] }, showErrors: true }, () => {
			ErrorHelpers.displayErrors(formEl, this.state.errors);
		});
	};

	addAdvertiserData = () => {
		const advertiserKeys = Object.keys(this.state.advertiserFields);
		const postObjectArray = [];
		advertiserKeys.forEach((key) => {
			if (this.state[key] && !MasterCampaignsStore.getAdvertiserSuccess().includes(key)) {
				const postData = { ...this.state[key].postData };

				const strippedTaxonomyPostData = [];
				for (const i in this.state[key].postData.TaxonomyData) {
					strippedTaxonomyPostData.push(postData.TaxonomyData[i]);
				}
				const strippedMetadataPostData = [];
				for (const i in this.state[key].postData.MetaData) {
					strippedMetadataPostData.push(postData.MetaData[i]);
				}
				if (strippedMetadataPostData.length + strippedTaxonomyPostData.length > 0) {
					postData.MetaData = strippedMetadataPostData;
					postData.TaxonomyData = strippedTaxonomyPostData;
					const contextValues = BookFiltersStore.getContextValues();
					let auditLevelID = null;
					let platformID = null;
					MasterCampaignsStore.getAdvertisers().forEach((advertiser) => {
						if (key === advertiser.PlatformName) {
							auditLevelID = advertiser.HierarchyLevelID;
							platformID = advertiser.MasterPlatformID;
						}
					});
					if (auditLevelID && platformID !== null) {
						const formSubmissionObj = {
							MasterAgencyDivisionName: contextValues?.agency?.name,
							MasterBusinessUnitName: contextValues?.client?.name,
							MasterCountryCode: contextValues?.country?.name,
							ContextID: contextValues.contextId,
							MasterRegionCode: contextValues?.region?.name,
							AuditLevelID: auditLevelID,
							PlatformID: platformID,
							AdvertiserData: {
								MasterCampaignID: MasterCampaignsStore.getNewCampaign().MasterCampaignUniqueIDCode,
								MasterPlatformID: platformID
							},
							...postData
						};
						postObjectArray.push([key, formSubmissionObj, "create"]);
					}
				}
			}
		});

		if (postObjectArray.length === 0) {
			this.setState({ loading: false }, () => {
				this.triggerOpenClose();
			});
		} else {
			this.setState({ totalAdvertisers: postObjectArray.length }, async () => {
				try {
					const { values, errors } = await createAdvertisers(postObjectArray);
					if (Object.keys(errors || {}).length === 0) {
						this.handleAdvertiserSuccess();
					}
				} finally {
					this.setState({ loading: false });
				}
			});
		}
	};

	sendPostObject = (newRowObj) => {
		this.postObject = this.formDataObjForPost(newRowObj);
		if (this.postObject) {
			putCampaignData(this.postObject).then(this.props.reloadGrid);
		}
		if (this.postObject === undefined) {
			this.setState({ loading: false });
		}
	};

	handleSubmit = (e) => {
		if (this.state.loading === false) {
			MasterCampaignsStore.resetAdvertisersErrors();
			this.setState({ loading: true, totalAdvertisers: 0 }, () => {
				e.preventDefault();
				if (MasterCampaignsStore.getNewCampaign() === null) {
					this.sendPostObject(this.state.formData);
				} else {
					this.addAdvertiserData();
				}
			});
		}
	};

	handleReset = () => {
		ErrorHelpers.resetErrors(formEl);
	};

	checkForEmptyPlatforms = () => {
		const rows = this.state.additionalRows.length;
		for (let i = 1; i <= rows; i++) {
			if (this.state.formData[`Platform_${i}`] === undefined) {
				this.handleAdditionalMediaChannelRemoval(null, null, i);
			}
		}
	};

	handleAdvertiserSuccess = () => {
		this.setState({ totalAdvertisers: 0, loading: false }, () => {
			this.props.reloadGrid();
			this.triggerOpenClose();
		});
	};

	handleAdvertiserErrors = () => {
		this.setState({ loading: false, advertisersErrors: {} }, () => {
			this.checkForEmptyPlatforms();
			Object.keys(MasterCampaignsStore.getAdvertiserErrors()).forEach((advertiserField) => {
				const errors = MasterCampaignsStore.getAdvertiserErrors()[advertiserField] || {};
				if (Object.keys(errors).length > 0) {
					const { advertisersErrors } = this.state;
					advertisersErrors[advertiserField] = {};
					Object.keys(errors).forEach((errorFieldName) => {
						errors[errorFieldName].forEach((errorName) => {
							advertisersErrors[advertiserField][errorFieldName] = errorName;
						});
					});
					this.setState({ advertisersErrors });
				}
			});
		});
	};

	handleErrors = () => {
		this.setState({ loading: false }, () => {
			this.checkForEmptyPlatforms();
			const errors = MasterCampaignsStore.getErrors();
			if (Object.keys(errors).length > 0) {
				const campaignErrors = errors.campaign;
				const type = "create mastercampaign";
				this.setState({ errors: campaignErrors, showErrors: true }, () => {
					ErrorHelpers.displayErrors(formEl, this.state.errors, type);
				});
			}
		});
	};

	/* Needed for all Modals */
	triggerOpenClose = (event) => {
		if (this.state.loading === false) {
			ModalHelpers.openCloseCLModal(event, this.updateModalState, this.state, initialState, () => {
				ErrorHelpers.resetErrors(formEl);
				this.removeAdvertiserFields();
			});
		}
	};

	updateModalState = () => {
		this.rowCount = 0;
		this.setState({
			open: !this.state.open,
			...initialState,
			additionalRows: [
				{
					id: this.rowCount
				}
			],
			mediaChannelsPlatforms: this.props.mediaChannelsPlatforms,
			advertisers: this.props.advertisers,
			excludedPlatformIDs: [],
			permissionedOptions: {}
		});
	};
	/* END */

	handleSuccess = () => {
		showToast(
			"masterCampaignToasts",
			<ToastNotification
				type={TOAST_TYPE.SUCCESS}
				message="New primary campaign has been added to the system and is now visible as the first row in the table"
				timed={5000}
			/>
		);
		ErrorHelpers.resetErrors(formEl);
		this.addAdvertiserData();
	};

	deleteFormDataDynamically = (formData, id) => {
		delete formData[`Platform_${id}`];
		return formData;
	};

	deletePostDataDynamically = (postData, id) => {
		if (postData.CampaignConfig !== undefined) {
			delete postData.CampaignConfig[`Platform_${id}`];
		}
		return postData;
	};

	rebuildExclusionList = () => {
		const idsToExclude = [];
		const currentFormData = Object.entries(this.state.formData);
		currentFormData.forEach((element) => {
			if (element[0].indexOf("Platform") !== -1) {
				if (typeof element[1] !== "undefined" && element[1] !== null) {
					idsToExclude.push(element[1].value.value);
				}
			}
		});

		return idsToExclude;
	};

	removePlatformFromExclusion = (id) => {
		const excludedIDs = this.state.excludedPlatformIDs;
		if (id) {
			if (this.state.formData[`${id}`]) {
				const platformID = this.state.formData[`${id}`].value.value;
				for (let i = 0; i < excludedIDs.length; i++) {
					if (excludedIDs[i] === platformID) {
						excludedIDs.splice(i, 1);
					}
				}
			}
		}

		return excludedIDs;
	};

	removeAdvertiserFields = () => {
		Object.keys(this.state.advertiserFields).forEach((advertiser) => {
			if (this.state[advertiser]) {
				delete this.state[advertiser];
			}
		});
		MasterCampaignsStore.resetNewCampaign();
		MasterCampaignsStore.resetAdvertisersErrors();
		MasterCampaignsStore.resetAdvertisersSuccess();
		this.setState({ advertisersErrors: {} });
	};

	handleAdditionalMediaChannelRemoval = (e, item, id) => {
		if (e) {
			e.preventDefault();
		}
		if (this.state.formData[`Platform_${id}`]) {
			if (this.state.formData[`Platform_${id}`].value) {
				if (this.state.formData[`Platform_${id}`].value.label) {
					if (this.state[this.state.formData[`Platform_${id}`].value.label]) {
						delete this.state[this.state.formData[`Platform_${id}`].value.label];
					}
				}
			}
		}
		const excludedIDs = this.removePlatformFromExclusion(`Platform_${id}`);
		const additionalRows = this.state.additionalRows.filter((i) => i.id !== id);
		const formData = this.deleteFormDataDynamically(this.state.formData, id);
		const postData = this.deletePostDataDynamically(this.state.postData, id);

		this.setState({
			additionalRows,
			excludedPlatformIDs: excludedIDs,
			formData,
			postData
		});
	};

	renderAdditionalPlatformDropdown = () => {
		return (
			<div className="platform_container" key="Platform">
				<Dropdown
					className="selectPlatform"
					placeholder="Select Platform..."
					name={`Platform`}
					onChange={(selectedOption) => {
						this.handlePlatformChange(selectedOption, `Platform`, "CampaignConfig", `Platform`, this.updateCustomState, `Platform`);
					}}
					options={this.filterPlatforms(this.state.mediaChannelsPlatforms)}
					dataConfig={"CampaignConfig"}
					disabled={Boolean(this.state.formData.Platform && MasterCampaignsStore.getAdvertiserSuccess().includes(this.state.formData.Platform.value.label))}
					value={this.state.formData.Platform ? this.state.formData.Platform.value : null}
					isClearable={true}
					id={`Platform`}
					multiple={true}
					required={true}
					isSearchable={true}
					closeMenuOnSelect={true}
				>
					Activation Platforms
				</Dropdown>
			</div>
		);
	};

	renderAdvertiserFields = () => {
		const platforms = this.state.formData.Platform?.value || [];

		return platforms.map(({ label: platformLabel, value }) => {
			const advertiser = this.state.advertiserFields[platformLabel];
			if (advertiser) {
				return (
					<AdvertiserFormBuilder
						type={`create ${platformLabel}`}
						data={this.state.advertiserFields[platformLabel]}
						configName="CampaignConfig"
						onUpdate={this.updateAdvertiserState}
						state={this.state[platformLabel] || {}}
						errors={this.state.advertisersErrors}
						advertiser={platformLabel}
					/>
				);
			}
			if (this.state.formData.Platform && !this.state.advertiserFields[platformLabel]) {
				return <></>;
			}
		});
	};

	updateAdvertiserState = (dataConfig, name, value, id, dataType, advertiser) => {
		if (this.state.loading === false) {
			UpdateStateHelper.updateAdvertiserFields(dataConfig, name, value, id, dataType, formEl, this, advertiser, this.state.advertiserFields[advertiser]);
		}
	};

	render() {
		const isDisabled = this.state.loading ? "disabledModal" : "";
		if (this.props.config && this.props.config.CampaignConfig[0]) {
			this.props.config.CampaignConfig[0].Label = "Campaign Name";
		}
		return (
			<>
				<Modal
					id="master__campaign"
					className={`master--campaign ${isDisabled}`}
					heading="Add Primary Campaign"
					description="Enter a Primary campaign name and select one or more activation platforms. Then, click the Add button to create a new primary campaign."
					isOpen={this.state.open}
					size={MODAL_SIZE.MEDIUM}
					onRequestClose={() => {
						if (this.state.open) {
							this.triggerOpenClose();
						}
					}}
					userClosable={true}
					onClick={() => {}}
					actionSetProps={{
						actionsRight: (
							<>
								<Button display="secondary" onClick={this.triggerOpenClose} data-tracking-id-alt="cancel-add-primary-campaign">
									Cancel
								</Button>
								<Button display="primary" disabled={!this.state.isFormDataValid} onClick={this.handleSubmit} data-tracking-id-alt="confirm-add-primary-campaign">
									Add
								</Button>
							</>
						)
					}}
				>
					{this.state.loading && <Loading className="modalLoading" />}
					<form className="createCampaign" id="createCampaign" autoComplete="off">
						<div className="campaign-config-container">
							<FormBuilderV2 type="create mastercampaign" data={this.props.config} configName="CampaignConfig" onUpdate={this.updateState} state={this.state} />
							{this.renderAdditionalPlatformDropdown()}
						</div>
						<div className="advertiser-fields-container">{this.renderAdvertiserFields()}</div>

						<AccessPermissions
							type="master"
							permissionedOptions={this.state.permissionedOptions}
							onChange={(value, dataKey) => {
								const { permissionedOptions } = this.state;
								permissionedOptions[dataKey] = value;
								this.setState({ permissionedOptions }, () => {
									this.isFormValid();
								});
							}}
						/>
						{this.state.showErrors && <div id="errors__container" />}
					</form>
				</Modal>
			</>
		);
	}
}

export default CreateCampaign;
